import {
  sunnyOutline,
  partlySunnyOutline,
  cloudyOutline,
  rainyOutline,
  thunderstormOutline,
  snowOutline,
} from 'ionicons/icons';

export interface WeatherInfo {
  icon: string;
  label: string;
}

/**
 * Open-Meteo (WMO) hava durumu kodlarını ikon + Türkçe etikete çevirir.
 * Kod listesi: https://open-meteo.com/en/docs (WMO Weather interpretation codes)
 */
export function getWeatherInfo(code: number): WeatherInfo {
  if (code === 0) {
    return { icon: sunnyOutline, label: 'Açık' };
  }
  if (code === 1 || code === 2) {
    return { icon: partlySunnyOutline, label: 'Parçalı Bulutlu' };
  }
  if (code === 3) {
    return { icon: cloudyOutline, label: 'Bulutlu' };
  }
  if (code === 45 || code === 48) {
    return { icon: cloudyOutline, label: 'Sisli' };
  }
  if ([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(code)) {
    return { icon: rainyOutline, label: 'Yağmurlu' };
  }
  if ([71, 73, 75, 77, 85, 86].includes(code)) {
    return { icon: snowOutline, label: 'Karlı' };
  }
  if ([95, 96, 99].includes(code)) {
    return { icon: thunderstormOutline, label: 'Gök Gürültülü Sağanak' };
  }
  return { icon: cloudyOutline, label: 'Bilinmiyor' };
}
